import React from 'react'
// @src imports

import Orders from 'src/orders/containers/Orders'
import Pricing from 'src/marketing/plans/containers/Pricing'
import { CampaignsRouter } from 'src/campaigns/components'
import Dashboard from 'src/dashboard/containers/Dashboard/Dashboard'
import CatalogPage from 'src/catalog/containers/CatalogPage'
import ContactManager from 'src/contacts/containers/ContactManager'
import GroupManager from 'src/contacts/containers/GroupManager'
import ImportManager from 'src/import-contacts'
import GiftStore from 'src/gift_store/containers/GiftStore'
import { InvalidMagicLink } from 'src/chrome'
import { InvalidMagicLinkRoute } from 'src/routes/InvalidMagicLinkRoute'
import { PricingRoute } from 'src/marketing/plans/routes/PricingRoute'
import { CatalogRoute } from 'src/catalog/routes/CatalogRoute'
import { RelationshipManagerRoute } from 'src/contacts/routes/RelationshipManagerRoute'
import { GroupsRoute } from 'src/contacts/routes/GroupsRoute'
import { ImportContactsRoute } from 'src/contacts/routes/ImportContactsRoute'
import { OrdersRoute } from 'src/orders/routes/OrdersRoute'
import { CampaignsRoute } from 'src/campaigns/routes/CampaignsRoute'
import { GiftStoreRoute } from 'src/gift_store/routes/GiftStoreRoute'
import { DashboardRoute } from 'src/dashboard/routes/DashboardRoute'
import { useSelector } from 'src/hooks'
import Awards from 'src/awards/containers/Awards'
import Card from 'src/card'
import { CardRoute } from 'src/card/routes/CardRoute'
import { AwardsRoute } from 'src/dashboard/routes/AwardsRoute'
import { FlexColumn } from 'src/styled'

const Router: React.FC = () => {
  const route = useSelector(state => state.route)

  switch (route.subroute.path) {
    case InvalidMagicLinkRoute.path:
      return <InvalidMagicLink route={route.subroute} />
    case AwardsRoute.path:
      return (
        <FlexColumn css={{ flex: 1, height: '100vh', overflow: 'auto' }}>
          <Awards />
        </FlexColumn>
      )
    case PricingRoute.path:
      return <Pricing route={route.subroute} />
    case CatalogRoute.path:
      return <CatalogPage route={route.subroute} />
    case GroupsRoute.path:
      return <GroupManager />
    case RelationshipManagerRoute.path:
      return <ContactManager route={route.subroute} />
    case ImportContactsRoute.path:
      return <ImportManager />
    case OrdersRoute.path:
      return <Orders route={route.subroute} />
    case CampaignsRoute.path:
      return <CampaignsRouter route={route.subroute} />
    case GiftStoreRoute.path:
      return <GiftStore route={route.subroute} />
    case DashboardRoute.path:
      return <Dashboard route={route.subroute} />
    case CardRoute.path:
      return <Card cardId={route.subroute.cardId} />
  }
}

export default Router
